import React, { useState, useEffect, useRef } from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import TCTLItem from "./tctlItem";
import * as styles from './twoColumnTileLarge.module.css';
import { gsap, TweenMax, Expo } from "gsap";

function TwoColumnTileLarge(props) {

    let sectionClass = styles.sectionTwoColumnTileLarge;
    if(props.alternateStyle){
        sectionClass += ' '+styles.alternateStyle;
    }

    const sectionRef = useRef();

    useEffect(() => {
        
        let isInViewport = (ins, os) => {
            let offset = (os) ? os : 0;
            if(ins.offset()){
                let elementTop = ins.offset().top + 10 - offset;
                let elementBottom = elementTop + ins.outerHeight() - offset;
                let viewportTop = $(window).scrollTop();
                let viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
            return false;
        }

        // TweenMax.set([sectionRef.current], {
        //     opacity: 0,
        //     y: 80
        // });

        if(!$(sectionRef.current).hasClass('anim-complete')){
            $(window).on('scroll', () => {
                if(isInViewport($(sectionRef.current), (0-($(window).height()/4)) )){

                    // TweenMax.to(
                    //     sectionRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         y: 0, 
                    //         delay : 0.25,
                    //         onComplete : () => {
                    //             $(sectionRef.current).addClass('anim-complete');
                    //         }
                    //     } 
                    // );

                    $(sectionRef.current).addClass('anim-complete');
                }
            });
        }

    });

    return (
        <div className={sectionClass} ref={sectionRef}>
            <div className={styles.sectionContainer}>
                <div className={styles.flexWrap}>

                
                    {
                        props.items.map((item, i) => {  
                            return <TCTLItem item={item} key={i} />
                        })
                    }

                </div>
            </div>
        </div>
    );
}

export default TwoColumnTileLarge;